import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import BrandIcon from "./BrandIcon";
import { useAuth } from "../contexts/AuthContext";

export default function MobileTabBar() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const tabs = [
    { to: "/", label: "상담", icon: "law", end: true },
    { to: "/ai-tools", label: "AI 도구", icon: "tools", related: ['/prediction', '/draft', '/digital-twin'] },
    { to: "/document-analysis", label: "문서", icon: "document" },
    { to: "/history", label: "이력", icon: "history" },
    { to: user ? "/mypage" : "/login", label: user ? "MY" : "로그인", icon: "user" },
  ];

  return (
    <nav className="mobile-tab-bar" aria-label="모바일 주요 메뉴">
      {tabs.map((tab) => (
        <NavLink
          key={`${tab.to}-${tab.label}`}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) => `mobile-tab-link ${isActive || tab.related?.includes(pathname) ? "is-active" : ""}`}
        >
          <BrandIcon name={tab.icon} size={21} strokeWidth={1.8} />
          <span className="mobile-tab-label">{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
